import React, { useState } from 'react'
import { observer } from 'mobx-react-lite'
import { ThreeDots } from 'react-bootstrap-icons'
import { toastError, toastSuccess } from '../../../../../../FormComponents/Toasts'
import EditLocationCommentOptions from './EditLocationCommentOptions'
import { useReadOnly } from '../../../../../../../contexts/ReadOnlyContext'
import LinkifiedText from '../../../../../../Shared/LinkifiedText'


export default observer(function DraftLocationComment({ comment, deleteComment }) {
  const readOnly = useReadOnly()
  const [openEdit, setOpenEdit] = useState(false)

  return (
    <div className='p-2 overflow-x-visible'>
      <div className="flex">
        <img src={comment.authorAvatar} alt={comment.authorName} className="h-8 w-8 rounded-full object-cover mr-2" />
        <div className="relative flex-grow flex items-center justify-between">
          <div className="flex items-center">
            <p className="text-white text-md font-bold mr-2">{comment.authorName}</p>
            <p className='text-rb-dark-mode-lighter text-sm font-semibold'>{comment.postedAt}</p>
          </div>
          {!readOnly && (
            <button onClick={() => setOpenEdit(!openEdit)}>
              <ThreeDots className='text-white'/>
            </button>
          )}
          {
            openEdit && (
              <EditLocationCommentOptions
                isOpen={openEdit}
                onEdit={() => toastError('Feature coming soon!')}
                onDelete={() => deleteComment(comment)}
                onClose={() => setOpenEdit(false)}
              />
            )
          }
        </div>
      </div>

      <p className='text-rb-lighter-grey w-[225px] ml-10 text-left'>
        <LinkifiedText text={comment.comment} />
      </p>
    </div>
  )
})
